import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import S from 'app/features/newLanding/components/HeroBlock/HeroBlock.styled';
import Text from 'app/components/layout/Text.styled';
import ViewPlansCta from 'app/features/landing/viewPlansCta/components/ViewPlansCta';
import Perks from 'app/features/newLanding/components/HeroBlock/Perks';
import UserGreeting from 'app/features/newLanding/components/HeroBlock/UserGreeting';
import { isGreetingLongerThan20Chars } from 'app/features/user/selectors';
import { TOP } from 'app/analytics/constants/positions';

const UI = ({ isGreetingLongerThan20Chars }) => (
  <S.HeroBlock>
    <S.Content data-t="hero-block">
      <S.Title
        size="l"
        isGreetingLongerThan20Chars={isGreetingLongerThan20Chars}
      >
        <UserGreeting />
        <FormattedMessage id="new_landing_heroblock_title" />
      </S.Title>
      <S.SubtitleAndPerksHolder>
        <Text size="xl" as={S.Subtitle}>
          <FormattedMessage id="new_landing_heroblock_subtitle" />
        </Text>
        <S.PerksHolder>
          <Perks />
        </S.PerksHolder>
      </S.SubtitleAndPerksHolder>
      <S.ButtonHolder>
        <ViewPlansCta
          type="six"
          position={TOP}
          testId="hero-view-plans-button"
          textKey="buttons_view_premium_plans"
        >
          <FormattedMessage id="buttons_view_premium_plans" />
        </ViewPlansCta>
      </S.ButtonHolder>
    </S.Content>
    <S.ImageHolder>
      <S.Image
        data-t="hero-image"
        src={`${window.etp.config.assetsUrl}img/hime/himeIceCream.png`}
        srcSet={`${window.etp.config.assetsUrl}img/hime/himeIceCream@2x.png 2x`}
        alt="Hime"
      />
    </S.ImageHolder>
  </S.HeroBlock>
);

UI.propTypes = {
  isGreetingLongerThan20Chars: PropTypes.bool,
};

UI.defaultProps = {
  isGreetingLongerThan20Chars: false,
};

UI.displayName = 'Heroblock';

const Heroblock = connect({
  isGreetingLongerThan20Chars,
})(UI);

export { UI };

export default Heroblock;
